module.exports = __webpack_public_path__ + "media/images/lb/274-337aaf07a00130ec657a853ec4b0820b.svg";